import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import FooterContent from "../footer-content/footer-content.js";
import HeaderContent from "../header-content/header-content.js";
import "./generic-tracking-page.css";
import TabsComponent from "./tabs-component.js";
import TranslationFetcher from "./../translation-fetcher/translation-fetcher.js";

const GenericTrackingPage = ({ parameters, client, source, isDynamic}) => {
  const locale = parameters.locale;
  const { translationData, localePassed } = TranslationFetcher({ locale });
  const countryCode = translationData?.ctryCd;
  const myDHLCtryCd = translationData?.myDHLCtryCd;
  const myDHLCtryLocale = translationData?.myDHLCtryLocale;

  return (
    <div className="outer-body-container text-02">
      <HeaderContent
        toDisplayClientLogo={true}
        client={client}
        currentPage="resultsPage"
        locale={localePassed}
        countryCode={countryCode}
      />
      <div className="body-content">
        {/* <div className="column-results"></div> */}
        <div className="box-results" style={{paddingBottom: "0px"}}>
           <div>{/*className="contentbody" */}
            <div className="bold-text">
              <p>{translationData?.translations.resultTitle}</p>
              <p>{translationData?.translations.resultDesc}</p>            
            </div>     
            <div className="tab-container">
              <TabsComponent parameters={parameters} myDHLCtryCd={myDHLCtryCd} myDHLCtryLocale={myDHLCtryLocale} client={client} source={source} isDynamic={isDynamic}/>
            </div>
          </div>
        </div>
        {/* <div className="column-results"></div> */}
      </div>
      <FooterContent />
    </div>
  );
};

export default GenericTrackingPage;